import React from 'react';
import { Button, Grid, TextField, IconButton, DialogContent, DialogTitle, Dialog, Stack, Typography, Alert, Snackbar } from '@mui/material';
import { DownloadImages, GetFieldData, getImages2 } from 'API/Approval/api';
import { useState } from 'react';
import { useEffect } from 'react';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';
// import { Stack } from '@mui/system';
// import SubCard from 'ui-component/cards/SubCard';
// import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
// // import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { LoadingButton } from '@mui/lab';
// import { display } from '@mui/system';
import { FaImage } from 'react-icons/fa';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  height: '80vh',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  display: 'flex',
  objectFit: 'contain',
  boxShadow: 24,
  p: 4
};

export function KeyValueComponent(props) {
  //  const[EditState,setEditState]=React.useState(true)

  // console.log("title ",data.title);

  // const handleEditStateChange =()=>{
  //     setEditState(!EditState)
  // }
  const [userData, setUserData] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [ImageUrl, setImageUrl] = useState(null);
  const [ImageType, setImageType] = useState('');
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [isLoading, setIsLoading] = useState(false);

  const [ImageList, setImageList] = useState([]);
  const [DialogImageOpen, setDialogImageOpen] = useState(false);

  const handleFileOpen = (item, data) => {
    setImageList(data);
    console.log('item', item);

    setDialogImageOpen(true);
  };

  // const handleFileOpen = (item) => {
  //   getImages2(props.data[item.name.toLowerCase()], setImageUrl, setImageType, handleOpen, setIsLoading);
  // };

  const [OpenAlert, setOpenAlert] = useState(false);

  const handleOpenLoading = () => {
    setIsLoading(true);
  }

  const handleCloseLoading = () => {
    setIsLoading(false);
  }

  const handleOpenAlert = () => {
    setOpenAlert(true);
  };

  // const handleDownload = (url) => {
  //   console.log('url', url);

  //   const file_name = url["Display Name"];
  //   DownloadImages(props.data[url.name.toLowerCase()], file_name, handleOpenAlert, handleOpenLoading, handleCloseLoading);
  // };
  const handleDownload = (name, url) => {

    const file_name = name.name;
    {
      url && url.map((data) =>
      (
        DownloadImages(data, file_name, handleOpenAlert, handleOpenLoading, handleCloseLoading)
      )
      )
    }
    // DownloadImages(props.data[url.name.toLowerCase()], file_name, handleOpenAlert, handleOpenLoading, handleCloseLoading);

  };

  const DisplayItems = [
    {
      name: 'first_name',
      category: 'general_info',
      'Display Name': 'First Name'
    },
    // {
    //   "name": "middle_name",
    //   "category": "general_info",
    //   "Display Name": "Middle Name"
    // },
    {
      name: 'last_name',
      category: 'general_info',
      'Display Name': 'Last Name'
    },
    {
      name: 'dob',
      category: 'general_info',
      'Display Name': 'Dob'
    },
    {
      name: 'gender',
      category: 'general_info',
      'Display Name': 'Gender'
    },
    {
      name: 'father_name',
      category: 'general_info',
      'Display Name': 'Father/Spouse Name'
    },
    // {
    //   "name": "category",
    //   "category": "general_info",
    //   "Display Name": "Category"
    // },
    {
      name: 'category',
      category: 'general_info',
      'Display Name': 'Category'
    },
    {
      name: 'email_address',
      category: 'general_info',
      'Display Name': 'Email Address'
    },
    {
      name: 'mobile_number',
      category: 'general_info',
      'Display Name': 'Mobile Number'
    },
    {
      name: 'qualification',
      category: 'general_info',
      'Display Name': 'Qualification'
    },

    {
      name: 'address',
      category: 'home_address',
      'Display Name': 'Home Address'
    },
    {
      name: 'home_region',
      category: 'home_address',
      'Display Name': 'Region'
    },
    {
      name: 'pin_code',
      category: 'home_address',
      'Display Name': 'Pincode'
    },
    {
      name: 'state',
      category: 'home_address',
      'Display Name': 'State'
    },
    {
      name: 'district',
      category: 'home_address',
      'Display Name': 'District'
    },
    {
      name: 'home_sub_district',
      category: 'home_address',
      'Display Name': 'Sub District'
    },
    {
      name: 'village/town',
      category: 'home_address',
      'Display Name': 'City / Village Name'
    },
    {
      name: 'address',
      category: 'retail_address',
      'Display Name': 'Retail Address'
    },
    {
      name: 'pin_code',
      category: 'retail_address',
      'Display Name': 'Pincode'
    },
    {
      name: 'state',
      category: 'retail_address',
      'Display Name': 'State'
    },
    {
      name: 'district',
      category: 'retail_address',
      'Display Name': 'District'
    },
    {
      name: 'sub_district',
      category: 'retail_address',
      'Display Name': 'Sub District'
    },
    {
      name: 'village_town',
      category: 'retail_address',
      'Display Name': 'City / Village Name'
    },
    {
      name: 'savings_bank_name',
      category: 'banking_details',
      'Display Name': 'Savings A/c Bank Name'
    },
    {
      name: 'savings_account_number',
      category: 'banking_details',
      'Display Name': 'Bank Account Number'
    },

    {
      name: 'savings_account_holder_name',
      category: 'banking_details',
      'Display Name': 'Savings A/c Holder Name'
    },
    {
      name: 'savings_account_ifsc_code',
      category: 'banking_details',
      'Display Name': 'Savings A/c Ifsc code'
    },
    {
      name: 'aadharcard_file',
      category: 'kyc_file',
      'Display Name': 'Aadhaar'
    },
    {
      name: 'pancard_file',
      category: 'kyc_file',
      'Display Name': 'Pan'
    },
    {
      name: '10th_12th_marksheet',
      category: 'kyc_file',
      'Display Name': '10/12 Marksheet'
    },
    {
      name: 'statement_saving',
      category: 'kyc_file',
      'Display Name': 'Statement/Passbook copy/Cheque -savings'
    },
    {
      name: 'cir_report',
      category: 'kyc_file',
      'Display Name': 'CIR Report'
    },
    {
      name: 'statement_od_ca',
      category: 'kyc_file',
      'Display Name': 'Statement/Passbook copy/Cheque -OD/CA'
    },
    {
      name: 'address_proof',
      category: 'kyc_file',
      'Display Name': 'Address Proof'
    },
    {
      name: 'gst_certificate',
      category: 'kyc_file',
      'Display Name': 'GST Certificate'
    },
    {
      name: 'graduation_certificate',
      category: 'kyc_file',
      'Display Name': 'Graduation Certificate'
    }
    // {
    //   name: 'gst_certificate',
    //   category: 'kyc',
    //   'Display Name': 'Gst Certificate'
    // },
    // {
    //   name: 'profile_image',
    //   category: 'kyc',
    //   'Display Name': 'Profile Image'
    // }
  ];

  // useEffect(() => {
  //   if (props.userId && sessionStorage.getItem('UserType') === 'tm') {
  //     GetRequestById(setUserData, props.userId)
  //   }
  // }, [props.userId])

  useEffect(() => {
    if (sessionStorage.getItem('UserType') === 'ops' && props.data) {
      console.log('entered');
      const dummy = [];
      // console.log();
      // props.data.map(item => {
      //   dummy.push(item.field_name)
      // })

      if (dummy.length > 0) {
        GetFieldData(setUserData, dummy, props.userId);
      }
    }
  }, [props.data]);

  // const handleViewFile=(name)=>{
  //     console.log(name);
  //     console.log(userData);
  // }

  // Select List

  console.log(userData);

  return (
    <>
      <Dialog open={DialogImageOpen} maxWidth="md" fullWidth>
        <DialogTitle variant="h4">
          Documents
          <IconButton onClick={() => setDialogImageOpen(false)} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ width: '100%', padding: 2 }}>
            <Grid container spacing={2}>
              {ImageList && ImageList.map((file, index) => {
                return (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <LoadingButton
                      fullWidth
                      variant="outlined"
                      onClick={() => getImages2(file, setImageUrl, setImageType, handleOpen, setIsLoading)}
                      color="secondary"
                      startIcon={<FaImage />}
                      sx={{
                        textTransform: 'none',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}
                      loading={isLoading}
                    >
                      <Typography noWrap sx={{ maxWidth: '100%' }}>
                        {file
                          ? (() => {
                            // const text = file.split('-').splice(-3).join('');
                            const text = file.split('/').pop();
                            return text.length > 30 ? text.slice(20, text.length) : text;
                          })()
                          : ''}
                      </Typography>
                    </LoadingButton>
                  </Grid>
                );
              })}
            </Grid>
          </Stack>
        </DialogContent>
      </Dialog>
      <Grid container spacing={2}>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 3 }} open={isLoading || open}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          open={OpenAlert}
          anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          autoHideDuration={6000}
          onClose={() => setOpenAlert(false)}
        >
          <Alert onClose={() => setOpenAlert(false)} severity="error" variant="filled" sx={{ width: '100%' }}>
            Something went wrong
          </Alert>
        </Snackbar>
        <Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Box sx={style}>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 6,
                padding: '5px',
                top: 5,
                color: (theme) => theme.palette.grey[500]
              }}
            >
              <CloseIcon />
            </IconButton>
            {ImageType && ImageType === 'pdf' ? (
              <iframe src={ImageUrl} title="PDF Viewer" style={{ width: '100%', height: '500px', border: 'none' }} />
            ) : (
              <img src={ImageUrl} alt="img" style={{ width: '100%', objectFit: "contain" }} />
            )}
          </Box>
        </Modal>

        {DisplayItems.map((item, index) => {
          return (props.selected === 'General Information' && item.category === 'general_info') ||
            (props.selected === 'Home Address' && item.category === 'home_address') ||
            (props.selected === 'Banking Details' && item.category === 'banking_details') ||
            (props.selected === 'Retail Address' && item.category === 'retail_address') ? (
            <Grid item xl={6} md={4} sm={12} key={index}>
              <TextField
                label={item['Display Name']}
                // value={userData[item['Display Name']]?userData[item['Display Name']]:Array.isArray(userData)&&userData.map((sub)=>{
                //  return sub[item.field_name]
                // })}
                value={props.data ? props.data[item.name] : ''}
                fullWidth
                contentEditable={false}
                inputProps={{ readOnly: true }}
              />
            </Grid>
          ) : props.selected === 'KYC Details' && item.category === 'kyc_file' ? (
            // <Grid item xl={12} md={12} sm={12} key={index}>
            //   <table style={{ width: '100%' }}>
            //     <tr>
            //       <td>{item['Display Name']}</td>
            //       <td style={{ display: 'flex', alignItems: 'flex-end' }}>
            //         <ButtonGroup>
            //         <Button variant="contained" disabled={isLoading} onClick={() => handleFileOpen(item)}>
            //           View
            //         </Button>
            //         <Button onClick={() => handleDownload(item)}>{<DownloadIcon/>}</Button>
            //         </ButtonGroup>
            //       </td>
            //     </tr>
            //   </table>
            // </Grid>
            <Grid item xl={12} md={12} sm={12} key={index}>
              <Box display="flex" justifyContent="space-between" alignItems="center" p={1} borderBottom="1px solid #ddd">
                {/* Display Name */}
                <Typography variant="body1">{item['Display Name']}</Typography>

                {/* Button Group */}
                <Stack direction="row" spacing={1} alignItems="center">
                  <Button variant="contained" color='secondary' size='small' disabled={isLoading || !props.data[item.name.toLowerCase()]}
                    // onClick={() => handleFileOpen(item)}
                    sx={{
                      // width:'50%',
                      backgroundColor: '#688B2A',
                      color: '#FFFFFF',
                      borderRadius: '6px',
                      '&:hover': {
                        backgroundColor: '#688B2A'
                      }
                    }}
                    onClick={() => handleFileOpen(item, props.data[item.name])}
                  >
                    View
                  </Button>
                  <IconButton size='small' disabled={isLoading || !props.data[item.name.toLowerCase()]}
                    color="secondary"
                    // onClick={() => handleDownload(item)}
                    sx={{
                      color: '#688B2A',
                      '&:hover': {
                        borderColor: '#688B2A'
                      }
                    }}
                    onClick={() => handleDownload(item, props.data[item.name])}
                  >
                    <FileDownloadOutlinedIcon />
                  </IconButton>
                </Stack>
              </Box>
            </Grid>
          ) : null;
        })}
      </Grid>
    </>
  );
}
